<template>
    <div class="card-wrap">
        <!-- 海报保存 -->
        <div class="container2" v-if="photoShow" ref="invitationImgRef">
            <img src="@/assets/images/user/talk/background.png" alt="">
            <div style="z-index:999;position:relative;">
                <div class="title">
                    敬请扫码
                </div>
                <div class="qrcode" id="qrcode" ref="qrcodeBox"></div>
                <div class="userinfo">
                    <div class="user-name-title">邀约人:</div>
                    <div class="user-name">{{ReportUserInfoData.sign_name}}</div>
                    <div>联系方式:</div>
                    <div>{{ReportUserInfoData.sign_phone}}</div>
                </div>
            </div>
        </div>
        <!-- 主要内容 -->
        <div class="card-title flc">
            <div class="color-block"></div>
            <div class="card-title-text">体验预约</div>
        </div>
        <div class="select-list">
            <div class="select-item" @click="choose('user')">
                {{user == undefined?defaultUser:user}}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
            <div class="select-item" @click="peopleChoose  = true">
                {{peopleName.length == 0 ?'支持人员':peopleName.join(',')}}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
            <div class="select-item" @click="choose('room')">
                {{room}}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
            <div class="select-date" @click="chooseTime">
                <div>{{currentDate == '' ?newDate.ymd:currentDate}}</div>
                <img src="@/assets/images/user/talk/time_icon.png" alt="">
            </div>
        </div>
        <div class="date-table">
            <div class="date-table-head">排期时间表</div>
            <table border="1" class="date-table-con" v-if="!isRest && ReportTimeData.length > 0">
                <tr v-for="(item,index) in ReportTimeData" :key="index">
                    <!-- 这个是分排渲染，先在数据中将数组中分成3个一组的数组，然后由于该时间段得内容是在这个时间段对象里面的，
                    所以需要复制一遍，就是类似[1,2,3]复制成[1,1,2,2,3,3],
                    实现分批次渲染，第一个1，第一个2，第一个3用来渲染时间段，然后第二个1,2,3用来渲染状态 -->
                    <!-- 时间段渲染 -->
                    <td style="background:#f7f7f7;" v-for="(item2,index2) in item" :key="index2" v-if="index % 2 == 0">
                        {{item2.start_at}}~{{item2.end_at}}
                    </td>
                    <!-- 预约状态渲染 -->
                    <td v-for="(item2,index2) in item" :key="index2" v-if="index % 2 != 0" :class="{
                            agree:item2.report.is_mine == 0,
                            preview:item2.report.is_mine == 1,
                            nowagree:MineAppointArr.findIndex( i2 => i2.index == index&& i2.index2 == index2) != -1
                        }"  @click="tableClick(index,index2,item2.report)">
                        <span v-if="item2.report.state == 1">
                            <span v-if="item2.report.is_mine == 1">预约人：{{item2.report.sign_name}}<br>{{item2.report.uname}}已预约</span>
                            <span v-else>预约人：{{item2.report.sign_name}}<br>客户已预约</span>
                        </span>
                        <span v-if="item2.report.state == 0">
                            {{notAccept(index,index2)}}
                        </span>
                        <span v-if="item2.report.state == 2">
                            <span v-if="item2.report.is_mine == 1">预约人：{{item2.report.sign_name}}<br>{{item2.report.uname}}未接受</span>
                            <span v-else>预约人：{{item2.report.sign_name}}<br>客户未接受</span>
                        </span>
                        <span v-if="item2.report.state == 3">
                            <span v-if="item2.report.is_mine == 1">预约人：{{item2.report.sign_name}}<br>{{item2.report.uname}}已接受</span>
                            <span v-else>预约人：{{item2.report.sign_name}}<br>客户已接受</span>
                        </span>
                        <span v-if="item2.report.state == 4">
                            <span v-if="item2.report.is_mine == 1">预约人：{{item2.report.sign_name}}<br>{{item2.report.uname}}已体验</span>
                            <span v-else>预约人：{{item2.report.sign_name}}<br>客户已体验</span>
                        </span>
                        <span v-if="item2.report.state == 9">
                            {{notAccept(index,index2)}}
                        </span>
                        <span v-if="item2.report.state == null">{{notAccept(index,index2)}}</span>
                    </td>
                </tr>
            </table>
            <div class="isRest" v-else-if="isRest">休息日</div>
            <div class="isRest" style="color:#b1b1b1;" v-else-if="ReportTimeData.length == 0 ">暂无信息</div>
        </div>
        <!-- <div class="remark-wrap"> -->
            <!-- <span v-if="!mark">备注</span> -->
            <!-- <span v-else>{{ mark }}</span> -->
            <!-- <textarea v-model="mark" placeholder="备注：请先输入备注，再点击时间段预约。"></textarea> -->
        <!-- </div> -->
        <div class="btn-wrap1">
            <div class="btn-wrap1-item">
                <div class="btn1" @click="cancelApply">取消预约</div>
                <div class="btn1 confirmApply" @click="confirmApply">确定预约</div>
            </div>
            <div class="btn2 " @click="GenerateInvitation">生成邀请函</div>
        </div>

        <!--vant弹出层-->
        <van-popup class="date-select-pop" v-model="dateSelectShow" position="bottom">
            <van-datetime-picker
                type="date"
                title="选择日期"
                @cancel="dateSelectShow = false"
                @confirm="selectDate"
                :min-date="minDate"
            />
        </van-popup>
        <van-popup class="date-pop" v-model="show">
            <div class="pop-wrap">
                <div class="pop-title">是否确认预约该时间段</div>
                <div class="pop-content">
                    <p v-if="currentDate != ''">{{currentDate.split('-')[0] + '年' +currentDate.split('-')[1] + '月' +currentDate.split('-')[2] + '日'}}</p>
                    <p v-else>{{newDate.ymd.split('-')[0] + '年' +newDate.ymd.split('-')[1] + '月' +newDate.ymd.split('-')[2] + '日'}}</p>
                    <p v-for="(item,index) in currentTimeSlotsort" :key="index">
                        {{item.start_at}} ~ {{item.end_at}}
                    </p>
                </div>
                <div class="texttare-class">
                    <textarea v-model="mark" placeholder="请输入备注："  class="text-style" name="" id="" cols="30" rows="8"></textarea>
                </div>
                <div class="pop-btn-wrap">
                    <div class="pop-btn" @click="show = false">取消</div>
                    <div class="pop-btn" @click="confirm">确认预约</div>
                </div>
            </div>
        </van-popup>
        <van-popup class="date-pop" v-model="showCancel">
            <div class="pop-wrap cancelPopups">
                <div class="pop-title">该操作会取消预约哦</div>
                <div class="pop-btn-wrap" style="margin-top:25px;">
                    <div class="pop-btn" @click="showCancel = false">取消</div>
                    <div class="pop-btn" @click="Cancelconfirm">确定</div>
                </div>
            </div>
        </van-popup>
        <!-- 海报 -->
        <van-popup class="poster-pop" v-model="posterShow" @close='popupClose'>
            <div class="poster-pop-wrap">
                <div class="container">
                    <img :src="photo_url" class="poster" alt="">
                    <img class="logo" src="@/assets/images/user/talk/logo.png" alt="">
                    <img class="right" src="@/assets/images/user/talk/right.png" alt="">
                    <img class="left" src="@/assets/images/user/talk/left.png" alt="">
                    <div class="center">
                        <div class="title">
                            AI-LiNK体验邀请函
                        </div>
                        <div class="content">
                            <p>尊敬的    <span>{{ReportUserInfoData.uname}}</span>       先生/女士</p>
                            <!-- <p>尊敬的    <span></span>       先生/女士</p> -->
                            <p>您好！</p>
                            <p>特邀您前往A.O.史密斯AI-LiNK城市体验中心，对AI-LiNK冷暖风水专业集成系统的设计、施工及使用效果进行体验，期待您的光临！</p>
                        </div>
                        <div class="accept">
                            <img class="acceptimg" src="@/assets/images/user/talk/accept.png" alt="">
                        </div>
                    </div>
                    <div class="address">
                        <div class="addr">
                            <p><span class="address-title">体验地址</span><span class="address-name">{{ReportUserInfoData.experience_name}}</span></p> 
                            <p class="address-addr">详细地址：{{ReportUserInfoData.experience_address}}</p>
                            <!-- <p><span class="address-title">体验地址</span><span class="address-name"></span></p> -->
                            <!-- <p class="address-addr">详细地址：</p> -->
                        </div>
                        <div class="navigation">
                            <img src="@/assets/images/user/talk/navigation.png" alt="">
                        </div>
                    </div>
                    <div class="time">
                        <div>体验时间</div>
                        <div>{{ReportUserInfoData.mark_start}}</div>
                    </div>
                    <div class="userinfo">
                        <span class="user-name-title">邀约人:</span>
                        <span class="user-name">{{ReportUserInfoData.sign_name}}</span>
                        <span>联系方式:</span>
                        <span>{{ReportUserInfoData.sign_phone}}</span>
                    </div>
                    <div class="bottom">
                        <div class="xieyi">
                            <span class="checkbox"><span class="check"></span></span>
                            <span>A.O.史密斯用户隐私授权条款</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="poster">
                    <img src="@/assets/images/user/talk/logo.png" alt="" class="logo">
                </div> -->
                <div class="pop-btn-wrap2">
                    <div class="item1">
                        <div class="pop-btn" @click="changeInfo">取消</div>
                        <div class="pop-btn" @click="Forwarding">确认转发</div>
                    </div>
                    <div class="item2">
                        <div class="pop-btn" @click="savePhoto">长按保存海报</div>
                        <!-- <div class="pop-btn" @click="savePhoto">长按保存海报</div> -->
                        <img :src="photo_url" alt="">
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 二维码海报(隐藏在背景板下面) -->
        <!-- <van-popup class="poster-pop" style="z-index:-9!important;" v-model="photoShow" @close="popupClose">
            <div class="poster-pop-wrap">
                <div class="container2" ref="invitationImgRef">
                    <div class="title">
                        敬请扫码
                    </div>
                    <div class="qrcode" id="qrcode" ref="qrcodeBox">
                    </div>
                    <div class="userinfo">
                        <div class="user-name-title">邀约人:</div>
                        <div class="user-name">{{ReportUserInfoData.sign_name}}</div>
                        <div>联系方式:</div>
                        <div>{{ReportUserInfoData.sign_phone}}</div>
                    </div>
                </div>
                <div class="pop-btn-wrap2">
                    <div class="item1">
                        <div class="pop-btn" @click="photoShow = false">取消</div>
                        <div class="pop-btn" @click="htmlToImage">保存</div>
                    </div>
                </div>
            </div>
        </van-popup> -->
        <!-- 潜客选择以及体验间列表选择 -->
        <van-popup class="chooseUsTem" v-model="topPopup" round position="bottom">
            <div class="search">
                <van-search class="searchDiv" right-icon="search" left-icon="" v-model="TSearch" :placeholder="currentType == 'room'?'可搜索列表中没有的体验间':'请输入搜索关键词'" />
                <div class="addCustomer" v-if="currentType=='user'" @click="addCustomer">新增潜客</div>
            </div>
            <van-picker ref="choose"  :value-key="currentType == 'user'?'name':'templateName'" show-toolbar @confirm='confirmPopup' @cancel='cancelPopup' title="请选择" :columns="columns" />
        </van-popup>
        <!-- 人员选择 -->
        <van-popup style="height:83%;" @close="closePeopleChoose" v-model="peopleChoose" round position="bottom" class="choosePeople">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getbottom"
                 :immediate-check="false" :offset="100"
                >
                <van-checkbox-group  v-model="people">
                    <van-cell-group>
                        <van-cell >
                            <div class="chooseCell1">
                                <span>已选择人员</span><span @click="confirmPeople">确定</span>
                            </div>
                            <div class="choosePeopelBox">
                                <div class="item" v-for="(item,index) in peopleName" :key="index">
                                    <span>{{item}}</span>
                                    <span  @click="deletePeople(item)"><img src="@/assets/images/user/talk/delete.png" alt=""></span>
                                </div>
                            </div>
                        </van-cell>
                    </van-cell-group>
                    <van-search right-icon="search" left-icon="" v-model="search" placeholder="请输入搜索关键词" />
                    <van-cell-group>
                        <van-cell v-for="(item, index) in SupportData" clickable :key="index" :title="item.fullname" @click="toggle(index)" >
                        <template #right-icon>
                            <van-checkbox checked-color="#318544" :name="item" ref="checkboxes" />
                        </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </van-list>
        </van-popup>
        <van-popup class="share-pop" v-model="shareShow" position="bottom">
            <div class="share-pop-wrap">
                <div class="share-pop-title">
                    <div>分享方式</div>
                    <img src="@/assets/images/user/talk/pop-close-icon.png" alt="" @click="shareShow = false">
                </div>
                <div class="share-list">
                    <div class="share-item flc">
                        <div class="share-item-left flc">
                            <img src="@/assets/images/user/talk/share-wx.png" alt="">
                            <div>
                                工具栏会话<br>
                                发送内容到会话
                            </div>
                        </div>
                        <div class="share-item-right" @click="shareFriend">发送到会话</div>
                    </div>
                    <!-- <div class="share-item flc">
                        <div class="share-item-left flc">
                            <img src="@/assets/images/ant/details/link_icon.png" alt="">
                            <div>复制链接后发给用户</div>
                        </div>
                        <div class="share-item-right" @click="copy" id="express_info_right" :data-clipboard-text="shareLink">复制链接</div>
                    </div> -->
                </div>
                
            </div>
        </van-popup>
        <!-- 分享弹窗 -->
        <share :appointStatus="false" :bShowNrom.sync="bShowNrom" :confit="confit"></share>
    </div>
</template>

<script>
import share from "@/components/common/share/index"; //分享
import { fetchVerifyAuthForB} from '@/libsV2/havc.js'
import detail from "@/js/detail.js";
import QRCode from 'qrcodejs2'
import { Dialog} from 'vant';
import {getWxSingleConfig} from  '@/js/wx.js'
import html2canvas from 'html2canvas'
import { log } from 'util';
let OSS = require("ali-oss");
let progressTime = null;

    export default {
        name: "appointExpreise",
        components: {
            share
        },
        data() {
            return {
                loading:false,//选择人员触底
                finished:false,//选择人员触底
                photo_url:'',//海报地址
                shareLink:'',//分享的链接
                BactiveApply:'',//这个是为了在多选时候查看是已经选中了可预约的还是已经预约的,true代表已经选中了已预约的，就不能在选择可预约的了，如果是false则相反
                photoShow:false,//控制二维码海报的显示
                TSearch:'',//体验间搜索
                showCancel:false,//显示取消弹窗
                peopleChoose:false,
                show: false,
                topPopup:false,
                posterShow: false,
                shareShow: false,
                dateSelectShow: false, // 日期选择弹窗
                currentDate: '', //当前时间ymd
                columns:[], //picker使用的数组
                currentType:'', //picker使用的类型
                userObj:{},//潜客选中的所有信息
                people:[],
                room:'选择体验间',
                SupportObj: {
                    page:0,
                    limit:20,
                },
                search:'',//搜索的内容
                TemplateRoomObj:{},//样板间信息
                currentTimeSlot:[],//这个是确定预约的时候展示的时间段信息
                accountId : '',//潜客id
                currentTableIndex:{},//存储当前点击的index下表
                mark:'',//备注
                MineAppointArr:[],//当前签单手点击了的的index下表
                bShowNrom:false,//企业微信分享显示隐藏
                confit:{},//企业微信配置
            }
        },
        watch:{
            search:{
                // 支持人员搜索
                handler(newText,oldText) {
                    // 如果新老值只有空格上的区别就不触发
                    if (newText.trim() == oldText.trim()) {
                        return;
                    }
                    this.finished = false
                    const searchText = newText.trim();
                    this.SupportObj = {page:0,limit:20}
                    Promise.all([
                        this.$store.dispatch({type:'userTalkAppoint/getSupportData2',...this.SupportObj,search:searchText})
                    ]).then( () => {
                        // 因为搜索的时候需要切换渲染出来的数组，
                        // 但是如果直接切换，那么已选择的不会被选中。这个时候就需要循环已经被选中的人员，在新的数组中选中他，
                        // 从而实现修改了所有的人员，已被选中的还是处于被选的状态
                        const people = this.people
                        let newPeople = []
                        people.forEach( person => {
                            const obj = this.SupportData.find( item => {
                                return item.systemuserid == person.systemuserid
                            })
                            if (obj == undefined) {
                                newPeople.push(person)
                            } else {
                                newPeople.push(obj)
                            }
                        })
                        this.people = newPeople
                        this.columns = this.SupportData
                    })
                },
                deep:true,
            },
            TSearch:{
                // 潜客搜索和体验间搜索
                handler(newText,oldText) {
                    // 如果新老值只有空格差异就不触发
                    if ( newText.trim() == oldText.trim()){
                        return
                    }
                    // 如果currentType == 'user'说明这个时候是处于潜客列表选择，如果不是，说明这个时候是处于体验间列表
                    if (this.currentType == 'user') {
                        this.$store.dispatch({type:'userTalkAppoint/getCustomerData',page:0,limit:50,search:newText.trim()}).then(() => {
                            this.columns = this.CustomerData
                        })
                    } else {
                        this.$store.dispatch({type:'userTalkAppoint/getTemplateRoomData',accountid:this.userObj.accountid,search:newText.trim()}).then (() => {
                            this.columns = this.TemplateRoomData
                        })
                    }
                }
            }
        },
        created () {
            // $init(() => {
                fetchVerifyAuthForB (() => {
                    this.$store.dispatch({type:'userTalkAppoint/getSupportData',...this.SupportObj})
                    this.$store.dispatch({type:'userTalkAppoint/getCustomerData',page:0,limit:50})
                    this.$store.dispatch({type:'userTalkAppoint/getReportRestData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid})//休息日
                    this.currentDate = this.newDate.ymd
                })
            // })
        },
        // 设置路由守卫
        beforeRouteEnter (to,from,next) {
            next( vm => {
                // console.log(vm.newDate.ymd,'ymd');
                // console.log(vm.currentDate,'ymd2');
                // 当日期为今天的时候就让体验间时间段刷新，因为默认是切换到体验预约是不刷新的
                // if (vm.currentDate == vm.newDate.ymd) {
                    // vm.$store.dispatch({type:'userTalkAppoint/getSupportData',...vm.SupportObj})
                    // vm.$store.dispatch({type:'userTalkAppoint/getCustomerData',page:0,limit:50})
                    // vm.$store.dispatch({type:'userTalkAppoint/getReportRestData',experience_id:vm.TemplateRoomObj.new_srv_projectmgnid})//休息日
                    vm.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:vm.TemplateRoomObj.new_srv_projectmgnid,date:vm.currentDate})
                    vm.MineAppointArr = []
                    vm.$forceUpdate(); 
                // }
            }) 
        },
        methods: {
            // 触底刷新
            getbottom () {
                this.loading = true
                this.SupportObj.page += 1
                let length = this.SupportData.length
                this.$store.dispatch({type:'userTalkAppoint/getSupportData',...this.SupportObj}).then (() => {
                    console.log(this.SupportObj,'SupportObj');
                    this.loading = false;
                    console.log(this.SupportData.length , length,'length');
                    if (this.SupportData.length == length && length != 0) {
                    console.log(this.SupportData.length , length,'.......');
                        this.finished = true
                        console.log('触发函数');
                    }
                })
            },
            // 点击复制链接触发的函数
            copy () {
                this.shareLink = window.location.href.split('/hvac/talk/appoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.MineAppointArr[0].id
                let that = this;
                let clipboard = new this.$clipboard("#express_info_right");
                clipboard.on("success", function () {
                    that.$toast({
                        message: "复制成功",
                        duration: 1200,
                    });
                    clipboard.destroy();
                });
                clipboard.on("error", function () {
                    that.$toast({
                        message: "复制失败",
                        duration: 1200,
                    });
                });
            },
            // 新增潜客
            addCustomer () {
                // console.log('x');
                // console.log(window.location,'window');
                const origin = window.location.origin
                // console.log(origin.indexOf('test'),'find');
                // 如果携带这个 ‘test’ 说明是测试环境，如果不携带说明就是正式环境
                if (origin.indexOf('test') != -1) {
                    console.log('测试环境');
                    window.location.href='http://crmgcnt.hotwater.com.cn:8051/weixinqy/index.html#/account/edit'
                } else {
                    window.location.href='https://hvac.hotwater.com.cn:8061/api/WeixinSSO/Authorize?redirectUrl=/account/edit'
                }
            },
            // 弹窗关闭,清楚二维码
            popupClose () {
                // console.log('清楚二维码');
                this.$refs.qrcodeBox.innerHTML = ''
            },
             // 生成二维码
            crateQrcode () {
                // console.log(this.MineAppointArr,'arr');
                // console.log(this.$refs.qrcodeBox,'ref');
                console.log(window.location.href.split('/hvac/talk/appoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.MineAppointArr[0].id,'网址');
                var qrcode = new QRCode(this.$refs.qrcodeBox, {  
                    text: window.location.href.split('/hvac/talk/appoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.MineAppointArr[0].id,
                    // text: 'https://www.baidu.com/',
                    width: 90,  
                    height: 90,  
                    colorDark: '#000000',  
                    colorLight: '#ffffff',  
                    correctLevel: QRCode.CorrectLevel.L
                });
                // console.log(this.qrcode)
            },
            // 点击保存海报触发的函数
            savePhoto () {
                if (this.MineAppointArr.length > 0) {
                    this.photoShow = true
                    function compare(property1,property2){
                        return function(a,b){
                            var value1 = a[property1];
                            var value2 = b[property1];
                            if (value1 == value2) {
                                return a[property2] - b[property2]
                            } else {
                                return value1 - value2
                            }
                        }
                    }
                    this.MineAppointArr = this.MineAppointArr.sort(compare('index','index2'))
                    this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',report_id: this.MineAppointArr[0].id})

                } else {
                    Dialog({message: "请先选择时间段"})
                }
            },
            // 确定预约
            confirmApply () {
                // 必须选中列表不是空，而且当前选中状态是可选中的状态才会显示哪个弹窗,this.BactiveApply==fasle才说明现在的状态是可选中状态
                if (this.MineAppointArr.length > 0 && !this.BactiveApply) {
                    // 因为预约会生成一个id，这个id是递增的，所以只需要找到最大的那个id那么这个对象就会是最后一次预约的信息了
                    let obj = {}//这个用来存储当前用户上次预约的时间段信息
                    let report_id = 0;//这个用来存储最大的id
                    this.ReportTimeData.forEach( (item,index) => {
                        if (index % 2 != 0) {
                            item.forEach( ele => {
                                if (Object.keys(ele.report).length > 0) {
                                    if (ele.report.id > report_id && ele.report.user_id_ao == this.userObj.accountid && ele.report.user_id_ao == this.userObj.accountid) {
                                        obj = ele;
                                        report_id = ele.report.id
                                    }
                                }
                            })
                        }
                    })
                    // console.log(obj,'obj');
                    if (obj?.report) {
                        this.mark = obj?.report.mark
                    }
                    this.show = true
                } else {
                    Dialog({message:'请选择要预约的时间段'})
                }
            },
            // 确定取消预约
            Cancelconfirm () {
                console.log('取消');
                let report_id = []
                this.MineAppointArr.forEach(item => {
                    report_id.push(item.id)
                })
                this.$store.dispatch({type:'userTalkAppoint/SendReportCancel',report_id:report_id.join(',')}).then( () => {
                    this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate})
                })
                this.MineAppointArr = []
                this.showCancel = false
            },
            // 点击生成邀请函
            GenerateInvitation () {
                // 判断当前是否有选中时间段
                if (this.MineAppointArr.length == 0) {
                    Dialog({message:'请确认转发哪个时间段'})
                    return
                }
                // 判断选中时间段是否是已预约的
                if (!this.MineAppointArr[0].id) {
                    Dialog({message:'请选择已预约时间段进行操作'})
                    return
                }
                // 判断所有的被选中的时间段是不是同一个潜客预约的，如果是，就可以生成海报，如果不是，则提示用户不可以生成海报
                let every = this.MineAppointArr.every( item => {
                    return item.user_id_ao == this.MineAppointArr[0].user_id_ao
                })
                if (!every) {
                    Dialog({message:'分享海报只能同时选择同一个用户'})
                    return 
                }
                function compare(property1,property2){
                    return function(a,b){
                        var value1 = a[property1];
                        var value2 = b[property1];
                        if (value1 == value2) {
                            return a[property2] - b[property2]
                        } else {
                            return value1 - value2
                        }
                    }
                }
                this.photoShow = true
                this.posterShow = true
                this.MineAppointArr = this.MineAppointArr.sort(compare('index','index2'))
                // 生成邀请函就发送邀请给用户
                Promise.all([
                    this.$store.dispatch({type: 'userTalkAppoint/SendReportShare',report_id: this.MineAppointArr[0].id}),
                    this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',report_id: this.MineAppointArr[0].id})
                ]).then (() => {
                    this.$nextTick(() => {
                        this.crateQrcode()
                        this.$nextTick(() => {
                            console.log(this.ReportUserInfoData.sign_name,'sign_name');
                            this.htmlToImage()
                        })
                    })
                })
            },
            getShareImg(id) {
                let that = this;
                that.$store.commit("loadSwitch", true);
                detail.getShareImg({ nId: id }).then((res) => {
                    let img = new Image();
                    let image_url = res.result.image_url;
                    // img.onload = () => {
                    //     that.objImg = image_url;
                    //     this.$toast({
                    //         message:'您可长按保存图片'
                    //     })
                    // };
                    // img.src = image_url;
                    this.photo_url = image_url
                    console.log(this.photo_url,'url');
                    //  console.log("图片路径", res.result.image_url);
                });
            },
            async savePoster(sFileName) {
                let oData = {
                    image_url: sFileName,
                };
                let oSavePoster = await detail.getPoster(oData);
                let nPosterId = oSavePoster.result;
                //  console.log(nPosterId);
                // debugger
                // this.nRate = 100;
                clearInterval(progressTime);
                setTimeout(() => {
                    //  console.log(nPosterId);
                    // wx.miniProgram.redirectTo({
                    //     url: `/pages/case/poster/index?nId=${nPosterId}`
                    // });
                    // this.$router.push({ path: `/antshare/index?nId=${nPosterId}` });
                    this.getShareImg(nPosterId)
                    this.$store.commit("loadSwitch", false);
                }, 1000);
            },
            // 上传图片到oss
            async ossUploadImg(oOss, oFile) {
                let client = new OSS({
                    region: oOss.sts.region,
                    bucket: oOss.sts.bucket,
                    accessKeyId: oOss.sts.access_key_id,
                    accessKeySecret: oOss.sts.access_key_secret,
                    endpoint: oOss.sts.endpoint_internal,
                    stsToken: oOss.sts.security_token,
                    //cname: true,
                    // timeout:30,
                    secure: true,
                });
                try {
                    //  console.log(oOss.object_name, oFile);
                    client
                    .multipartUpload(oOss.object_name, oFile)
                    .then((res) => {
                        console.log(res);
                        let sFileName = res.name;
                        this.savePoster(oOss.filename); //保存海报
                    })
                    .catch((err) => {
                         console.log("错误信息", err);
                    });
                } catch (e) {
                    //  console.log(e);
                }
            },
            // 获取oss配置
            async getOssSts(sUrl) {
                let oOssData = await detail.getOsssts({
                    ext: "png",
                });
                let oOss = oOssData.result;
                //  console.log("加密数据", oOssData);
                let sKey = `tbzIwry9lT0qU81m${oOss.timestamp}`;
                // let oOssDecrypt = this.decrypt(sKey, oOss.body);
                // console.log('需要上传的图片',sUrl)
                let oFile = await this.base64ToLife(sUrl, oOss.key);
                this.ossUploadImg(oOss, oFile);
            },
            // base64 转 Blod
            base64ToLife(dataurl, filename) {
                return new Promise((resolve, reject) => {
                    const arr = dataurl.split(",");
                    const mime = arr[0].match(/:(.*?);/)[1];
                    const bstr = atob(arr[1]);
                    let n = bstr.length;
                    const u8arr = new Uint8Array(n);
                    while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                    }
                    let blod = new Blob([u8arr], { type: mime });
                    // blod.lastModifiedDate = new Date();
                    // blod.name = filename;
                    resolve(blod);
                });
            },
            //生成长图
            htmlToImage() {
                // console.log('父')
                let that = this;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                let sHeight = 604;
                let sWidth = 312;
                this.$store.commit("loadSwitch", true);
                html2canvas(that.$refs.invitationImgRef, {
                    useCORS: true,
                    backgroundColor:null,
                    dpi: 72,
                })
                    .then((canvas) => {
                        let sUrl = canvas.toDataURL("image/png",1);
                        this.getOssSts(sUrl);
                        this.$store.commit("loadSwitch", false);
                        // console.log(sUrl,'surl');
                        console.log('成功');
                    })
                    .catch((fail) => {
                        console.log('失败');
                        this.$store.commit("loadSwitch", false);
                        console.log(fail);
                    });
                console.log("长图", sHeight, sWidth);
            },
            // 确定选择人员
            confirmPeople () {
                this.peopleChoose = false
            },
            // 删除人员选择
            deletePeople (name) {
                const index = this.SupportData.findIndex( item => item.fullname == name)
                this.$refs.checkboxes[index].toggle();
            },

            closePeopleChoose () {
                // console.log(this.people,'people');
            },
            // 选择人员
            toggle(index) {
                this.$refs.checkboxes[index].toggle();
            },
            // 选择时间
            chooseTime () {
                // 判断是否选择了体验间
                if (Object.keys(this.TemplateRoomObj).length == 0) {
                    Dialog({message:'请先选择样板间'})
                    return
                }
                this.dateSelectShow = true
            },
            // 分享
            shareFriend () {
                let wechat = this.$storage.getStorage('is_wechat');
                // 微信环境
                if (wechat == 1) {
                    this.$toast({message:'请点击右上角转发...'})
                    // getWxSingleConfig(confit)
                } else if (wechat == 6) {
                    // 企业微信环境
                    wx.onMenuShareAppMessage(Object.assign({}, confit));
                }
                this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate})
                this.shareShow = false
            },
            // 确定选择
            confirmPopup (selected) {
                this.topPopup = false;
                console.log(selected,'selected');
                // 选择体验间以及选择潜客都需要使用到同一个弹窗，选择器，根据不同情况，使用不同的数组渲染
                // user  代表点击了支持人员
                // else  代表点击了体验间
                if (this.currentType == 'user') {
                    this.userObj = selected
                    // 选择完用户让他重新选择体验间
                    this.room = '选择体验间'
                    this.currentTimeSlot = []
                    this.TemplateRoomObj = {}
                    // 获取体验间时间段数据
                    this.$store.dispatch({type:'userTalkAppoint/getTemplateRoomData',accountid:selected.accountid})
                    // 获取报告id
                    this.$store.dispatch({type: 'userTalkAppoint/getReportId',accountid:selected.accountid});
                } else {
                    this.TemplateRoomObj = selected
                    this.room = selected.new_community
                    // 切换体验间也是需要让选中的晴空
                    this.MineAppointArr = []
                    this.currentTimeSlot = []
                    this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate})
                }
            },
            // 取消选择
            cancelPopup () {
                this.topPopup = false;
            },
            // 选择触发的函数
            choose (type) {
                // console.log(this.ReportRestData,'休息日');
                this.search = ''
                this.TSearch = ''
                this.currentType = type;
                this.topPopup = true
                // 判断是点击了潜客还是点击了体验间
                if (type == 'user') {
                    this.columns = this.CustomerData
                }  else {
                    // 判断是否已选择了潜客
                    if (Object.keys(this.userObj).length == 0) {
                        this.topPopup = false   
                        Dialog({message: '请先选择用户'});
                        return
                    }
                    this.columns = this.TemplateRoomData
                }
            },
            // 点击确认转发
            Forwarding () {
                let wechat = this.$storage.getStorage('is_wechat');
                let confit = {
                        share_friend_title: "A.O.史密斯AI-LiNK体验中心邀请函",
                        share_friend_desc: `体验地点: ${this.ReportUserInfoData.experience_name} \r\n 体验时间: ${this.ReportUserInfoData.mark_start}`,
                        share_img_url: "https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/shar-img.jpg",
                        share_link: window.location.href.split('/hvac/talk/appoint')[0] + '/user/invitation/invitation' + '?report_id=' + this.MineAppointArr[0].id
                };
                this.confit = confit;
                //jssdk
                getWxSingleConfig(confit)
                this.$store.commit("loadSwitch", false);
                if (wechat == 1) {
                    this.shareShow = true
                    // 微信环境下
                } else if (wechat == 6) {
                    // 企业微信环境下
                    this.bShowNrom = true;
                }
                this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate})
            },
            changeInfo () {
                this.posterShow = false
            },
            // 点击表格中的内容
            tableClick (index,index2,report) {
                // user_id_ao这个的作用是用来判断当前时间哪几个时间段是这个潜客的
                const {id,uname,is_mine,user_id_ao} = report
                // console.log(uname,id,'uname+id');
                //选中给默认备注(外面的备注框已注释)
                // this.mark = this.ReportTimeData[index][index2].report.mark;
                // 判断是否选择了体验间
                if ( Object.keys(this.TemplateRoomObj).length == 0 ) {
                    Dialog({message:'请先选择体验间'})
                    return
                }
                // 判断当前时间和点击预约的时间是否冲突,并且不能是没有预约的状态，只能是在已预约的时候，已预约的时候才可以选中，哪怕时间已经过期
                if (this.currentDate == this.newDate.ymd && this.ReportTimeData[index][index2].start_at < this.newDate.time && !this.BactiveApply && this.BactiveApply != '') {
                    // console.log(this.ReportTimeData[index][index2].start_at,this.newDate.time,'time');
                    // console.log(this.ReportTimeData[index][index2].start_at>this.newDate.time,'time');
                    Dialog({message:'您已错过该时间段'})
                    return
                } 
                // 判断是不是我本人预约的，如果是1说明就是我本人预约的，如果是0就不是我本人预约的
                if (is_mine == 1) {
                    // 当这个长度为0 的时候说明还没有选，此时选择已预约的，他就会是已预约的
                    // 如果长度不等于0，状态也不是已预约的选中状态，那么说明现在是可预约的选中状态，就不可以选中已预约的了
                    if (this.MineAppointArr.length == 0 ) {
                        this.BactiveApply = true
                        // 点击一个，同时点亮其他当前潜客今天约的时间段
                        let mineAppltArr = []
                        this.ReportTimeData.forEach( (item,index2) => {
                            // 这个判断的作用是分开时间渲染和状态渲染，因为在渲染的时候给这个数组复制了一份
                            if (index2 % 2 !=0) {
                                item.forEach( (ele,index3) => {
                                    if (ele.report.user_id_ao == user_id_ao) {
                                        mineAppltArr.push({
                                            index:index2,
                                            index2:index3,
                                            id:ele.report.id,
                                            uname:ele.report.uname,
                                            user_id_ao:user_id_ao
                                        })
                                    }
                                })
                            }
                        })
                        this.MineAppointArr = mineAppltArr
                        return
                    } else if (this.MineAppointArr.length != 0 && !this.BactiveApply) {
                        return
                    }
                    // 判断这个是否已经被选中了，如果被选中了就取消选中，如果没有选中，就选中
                    let objIndex = this.MineAppointArr.findIndex(item => item.index == index && item.index2 == index2)
                    console.log(index,index2,'index');
                    if (objIndex == -1 ) {
                        this.MineAppointArr.push({index,index2,uname,id,user_id_ao})
                    } else {
                        this.MineAppointArr.splice(objIndex,1)
                    }
                    return
                } else {
                    // 如果不是我本人预约的，又没有uname说明没有被人预约，如果有uname说明这个被其他签单手预约了
                    if (uname) {
                        return
                    } else {
                        // 近来这里说明选择的是可预约的
                        if (this.MineAppointArr.length == 0 ) {
                            this.BactiveApply = false
                        } else if (this.MineAppointArr.length != 0 && this.BactiveApply) {
                            return
                        }
                        // 判断是否已经有这个了，有就取消选中， 没有就选中
                        let objIndex = this.MineAppointArr.findIndex(item => item.index == index && item.index2 == index2)
                        // console.log(index,index2,'index');
                        // console.log(this.ReportTimeData[index][index2],'ide21');
                        // console.log(objIndex,'objIndex');
                        // console.log(this.MineAppointArr,'MineAppointArr');
                        // console.log(this.currentTimeSlot,'index3');
                        if (objIndex == -1 ) {
                            this.MineAppointArr.push({index,index2,uname,id,user_id_ao})
                            this.currentTimeSlot.push({
                                start_at:this.ReportTimeData[index][index2].start_at,
                                end_at:this.ReportTimeData[index][index2].end_at,
                            })
                        } else {
                            this.MineAppointArr.splice(objIndex,1)
                            // 因为currentTimeSlot有可能经过了排序展示时间，所以位置和一开始加进去的时候是不一样的
                            let start_at = this.ReportTimeData[index][index2].start_at
                            let end_at = this.ReportTimeData[index][index2].end_at
                            let objIndex2 = this.currentTimeSlot.findIndex(i => i.start_at == start_at && i.end_at == end_at)
                            this.currentTimeSlot.splice(objIndex2,1)
                        }
                        // console.log('67676767', this.currentTimeSlot)
                        this.currentTableIndex = {index,index2}
                        // 2次确认预约弹窗
                        // this.show =true;
                        // 2次确认预约弹窗的时间内容
                        // console.log(this.MineAppointArr,'mineobjk');
                    }
                }
            },
            /**
            * 选择日期确定
            */
            selectDate(val) {
                let year = val.getFullYear() // 年
                let month = (val.getMonth() + 1) < 10 ? ('0' + (val.getMonth() + 1)) : (val.getMonth() + 1) // 月
                let day = val.getDate() < 10 ? ('0' + val.getDate()) : val.getDate() // 日
                this.currentDate = `${year}-${month}-${day}`
                this.dateSelectShow = false
                this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate})
                this.MineAppointArr = []
                this.currentTimeSlot = []
                this.mark = ''
            },
            // 点击了弹窗中的确定预约触发的函数
            confirm () {
                const user = this.user
                const people = this.people
                const room = this.room
                // 判断是是否选择了用户，支持人员，体验间，以及判断选中的时间是否为1，如果是1，那就直接发送单个预约的请求就可以
                if (user == '选择用户') {
                    Dialog({message:'请选择用户后预约'})
                    return
                } else if (people[0] == '支持人员') {
                    Dialog({message:'请选择支持人员'})
                    return
                } else if (room == '选择体验间') {
                    Dialog({message:'请选择体验间'})
                    return
                }else if (this.currentTimeSlot.length == 1) {
                    // 进行到这里，说明是预约的一个时间段
                    const options = {
                        accountid:this.userObj.accountid,
                        prospects_ids:this.peopleId.join(','),
                        experience_id:this.TemplateRoomObj.new_srv_projectmgnid,
                        date:this.currentDate,
                        mark:this.mark,
                        ...this.currentTimeSlot[0],
                    }
                    this.$store.dispatch({type: 'userTalkAppoint/getReportId',accountid:this.userObj.accountid}).then( () => {
                        // 预约
                        this.$store.dispatch({type:'userTalkAppoint/getReportAppointData',...options}).then(() => {
                            this.mark = ''
                            // 修改状态
                            this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate}).then ( () => {
                                this.BactiveApply = true
                                this.currentTimeSlot = []
                                // console.log(this.MineAppointArr,'arr');
                                // 因为在可预约状态点击，id为undefined，预约完成之后，他还是undefined如果用户需要直接取消预约，那么就会因为id不存在报错
                                // 下面代码的作用就是给id重新赋值
                                let obj = {
                                    id:this.ReportTimeData[this.MineAppointArr[0].index][this.MineAppointArr[0].index2].report.id,
                                    uname:this.ReportTimeData[this.MineAppointArr[0].index][this.MineAppointArr[0].index2].report.uname,
                                    user_id_ao:this.ReportTimeData[this.MineAppointArr[0].index][this.MineAppointArr[0].index2].report.user_id_ao,
                                }
                                this.MineAppointArr[0] = Object.assign(this.MineAppointArr[0],obj)
                            })
                        })
                    })
                } else {
                    // 进行到这里，说明选中的是多个时间段不是一个时间段
                    // currentTimeSlot是选中的时间段
                    // console.log(this.currentTimeSlot,'slot');
                    this.$store.dispatch({type: 'userTalkAppoint/SendReportappoints',
                        accountid:this.userObj.accountid,
                        prospects_ids:this.peopleId.join(','),
                        experience_id:this.TemplateRoomObj.new_srv_projectmgnid,
                        date:this.currentDate,
                        mark:this.mark,
                        items:JSON.stringify(Object.assign({}, this.currentTimeSlot))
                    }).then( () => {
                        this.$store.dispatch({type:'userTalkAppoint/getReportTimeData',experience_id:this.TemplateRoomObj.new_srv_projectmgnid,date:this.currentDate}).then ( () => {
                            this.currentTimeSlot = []
                            this.BactiveApply = true
                            this.mark = ''
                            // 因为在可预约状态点击，id为undefined，预约完成之后，他还是undefined如果用户需要直接取消预约，那么就会因为id不存在报错
                            // 下面代码的作用就是给id重新赋值
                            this.MineAppointArr = this.MineAppointArr.map( (ele,i) => {
                                ele.id = this.ReportTimeData[ele.index][ele.index2].report.id
                                ele.uname = this.ReportTimeData[ele.index][ele.index2].report.uname
                                ele.user_id_ao = this.ReportTimeData[ele.index][ele.index2].report.user_id_ao
                                return ele
                            })
                        })
                    })
                }
                this.show = false
            },
            // 点击了弹窗中的取消触发的函数
            cancel () {
                this.show = false
            },
            // 点击了下面的取消预约按钮
            cancelApply () {
                if (this.MineAppointArr.length > 0) {
                    this.showCancel = true
                } else {
                    this.$toast({message:'您还没有选中要取消的预约'})
                }
            },
            // 当前状态是可预约，还是不可预约
            notAccept (index,index2) {
                let newDate = new Date();
                let minute = newDate.getMinutes();
                let second = newDate.getSeconds()
                let hour = newDate.getHours();
                hour = (hour < 10) ? '0' + hour : hour
                minute = (minute < 10) ? '0' + minute : minute
                second = (second < 10) ? '0' + second : second
                let time = hour + ':' + minute
                if (this.currentDate == this.newDate.ymd && this.ReportTimeData[index][index2].start_at <= time){
                    return '不可预约'
                } else {
                    return '可预约'
                }
            },
        },
        computed:{
            // 每次currentTimeSlot修改都给他重新按照时间顺序排序
            currentTimeSlotsort () {
                function compare (property) {
                    return function (a,b) {
                        let value1 = a[property].substring(0,2)
                        let value2 = b[property].substring(0,2)
                        if (value1 == value2) {
                            return a[property].substring(3,5) - b[property].substring(3,5)
                        } else {
                            return value1 - value2;
                        }
                    }
                }
                let list = this.currentTimeSlot.sort(compare('start_at')); 
                return list 
            },
            ReportUserInfoData() {
                return this.$store.state.userTalkAppoint.ReportUserInfoData
            },
            newDate () {
                let newDate = new Date();
                const year = newDate.getFullYear();
                let month = newDate.getMonth() + 1;
                let date = newDate.getDate();
                let minute = newDate.getMinutes();
                let second = newDate.getSeconds()
                let hour = newDate.getHours();
                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date
                hour = (hour < 10) ? '0' + hour : hour
                minute = (minute < 10) ? '0' + minute : minute
                second = (second < 10) ? '0' + second : second
                return {
                    ymd:year + '-' + month + '-' + date,
                    time:hour + ':' + minute
                }
            },
            minDate() {
                let newDate = new Date();
                const year = newDate.getFullYear();
                let month = newDate.getMonth();
                let date = newDate.getDate();
                month = (month < 10) ? '0' + month : month
                date = (date < 10) ? '0' + date : date
                return new Date(year, month, date)
            },
            
            // 支持人员
            SupportData() {
                return this.$store.state.userTalkAppoint.SupportData
            },
            // 潜客
            CustomerData () {
                return this.$store.state.userTalkAppoint.CustomerData
            },
            // 体验间
            TemplateRoomData () {
                return this.$store.state.userTalkAppoint.TemplateRoomData
            },
            // 体验间时间段
            ReportTimeData () {
                return this.$store.state.userTalkAppoint.ReportTimeData
            },
            // 休息日
            ReportRestData () {
                return this.$store.state.userTalkAppoint.ReportRestData
            },
            // // 默认带出用户
            defaultUser() {
                const id = this.$route.query.id
                if (id) {
                    // console.log(this.CustomerData,'this.CustomerData');
                    this.$store.dispatch({type:'userTalkAppoint/getCustomerObj',accountid:id}).then (() => {
                        this.userObj = this.$store.state.userTalkAppoint.CustomerObj
                        // 获取体验间时间段数据
                        this.$store.dispatch({type:'userTalkAppoint/getTemplateRoomData',accountid:this.userObj.accountid})
                        // 获取报告id
                        this.$store.dispatch({type: 'userTalkAppoint/getReportId',accountid:this.userObj.accountid});
                        return this.userObj.name
                    })
                }
                return '请选择用户'
            },
             //报告id
            ReportId() {
                return this.$store.state.userTalkAppoint.ReportId
            },
            peopleName () {
                const people = this.people
                let peopleList = [];
                people.forEach(person => {
                    peopleList.push(person.fullname);
                })
                return peopleList
            },
            peopleId () {
                const people = this.people
                let peopleId = [];
                people.forEach(person => {
                    peopleId.push(person.systemuserid);
                })
                return peopleId
            },
            // 判断今天是否休息
            isRest () {
                const index = this.ReportRestData.findIndex( item => item == this.currentDate)
                if (index != -1) {
                    return true;
                } else {
                    return false
                }
            },
            user () {
                const userObj = this.userObj
                return userObj.name
            }
        }
    }
</script>

<style lang="scss" scoped>
.chooseUsTem .search{
    display: flex;
    align-items: center;
    .searchDiv {
        flex: 1;
    }
    .addCustomer{
        margin-right: 20px;
        width: 170px;
        height: 60px;
        background: #318544;
        border-radius: 8px;
        text-align: center;
        line-height: 60px;
        font-size: 28px;
        font-weight: 400;
        color: #FFFFFF;
    }
}
::v-deep .chooseUsTem .van-picker__confirm{
    margin-right: 20px;
    width: 120px;
    height: 60px;
    background: #318544;
    border-radius: 8px;
    text-align: center;
    line-height: 60px;
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
}
::v-deep .chooseUsTem .van-picker__cancel{
    margin-left: 20px;
    width: 120px;
    height: 60px;
    border-radius: 8px;
    text-align: center;
    line-height: 60px;
    font-size: 28px;
    font-weight: 400;
}

    .card-wrap {
        width: 91.2%;
        z-index: 10;
        margin: 0 auto 32px;
        background: #FFFFFF;
        border-radius: 12px;
        padding: 28px 24px 250px;
        .container2{
            position: absolute;
            z-index: -1;
            top: -107vh;
            width: 624px;
            height: 1021px;
            padding-top:167px ;
            img {
                position: absolute;
                top: 0;
                left: 0;top: 0;
                bottom: 0;
                z-index: 9;
            }
            .title {
                text-align: center;
                margin-top: 376px;
                margin-bottom: 20px;
                color: #fff;
                font-size: 30px;
            }
            .qrcode {
                width: 200px;
                margin:0 auto 0;
                height: 200px;
                background-color: #fff;
                padding: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .userinfo {
                width: 100%;
                position: absolute;
                bottom:-60px;
                text-align: center;
                display: flex;
                justify-content: center;
                div:nth-child(1) {
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                div:nth-child(2) {
                    margin-left: 15px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                div:nth-child(3) {
                    margin-left: 20px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                div:nth-child(4) {
                    font-size: 21px;
                    margin-left: 15px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }    
        /*卡片标题*/
        .card-title {
            .color-block {
                width: 6px;
                height: 32px;
                background: #318544;
                margin-right: 12px;
            }
            .card-title-text {
                font-size: 32px;
                font-weight: 600;
                color: #318544;
                line-height: 44px;
            }
        }
        /*下拉选择列表*/
        .select-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 18px;

            .select-item {
                padding-right: 32px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                width: 100%;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #DBDBDB;
                margin-bottom: 20px;
                position: relative;
                font-size: 28px;
                font-weight: 400;
                color: #444444;
                line-height: 80px;
                text-align: center;

                &:first-child {
                    width: 248px;
                    padding-right: 32px;
                }
                &:nth-child(2) {
                    width: 368px;
                    padding-right: 32px;
                }

                img {
                    position: absolute;
                    width: 32px;
                    height: 32px;
                    right: 12px;
                    top: 24px;
                }
            }

            .select-date {
                width: 100%;
                border-radius: 12px;
                border: 2px solid #DBDBDB;
                height: 80px;

                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                div {
                    font-size: 24px;
                    font-weight: 400;
                    color: #A2A2A2;
                    line-height: 32px;
                }
                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }

        /*排期时间表*/
        .date-table {
            width: 100%;
            margin-top: 24px;

            .date-table-head {
                width: 100%;
                background: #F0F4F1;
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 72px;
                text-align: center;
            }
            .isRest {
                width: 100%;
                display: flex;
                justify-content:center;
                align-items: center;
                height: 350px;
                border: 1px solid #E5E5E5;
            }
            table {
                width: 100%;
                border: 2px solid #E5E5E5;
                text-align: center;
                border-top: none;
                tr {
                    border-bottom: 2px solid #E5E5E5;
                    td {
                        border-right: 2px solid #E5E5E5;
                        vertical-align: middle;
                    }

                    &:nth-child(odd) {
                        td {
                            width: 33%;
                            font-size: 24px;
                            font-weight: 400;
                            color: #444444;
                            line-height: 72px;
                        }
                    }
                    &:nth-child(even) {
                        height: 96px;
                    }

                    .agree {
                        background: rgba(235, 111, 86, 0.11);
                        font-size: 24px;
                        font-weight: 400;
                        color: #EB6F56;
                        line-height: 32px;
                    }
                    .preview {
                        background: #ffffff;
                        color: rgba(49, 133, 68, 1);
                    }
                    .nowagree {
                        background: rgba(49, 133, 68, 0.11);
                        color: rgba(49, 133, 68, 1);
                    }
                }
            }
        }

        /*备注文本域*/
        .remark-wrap {
            margin-top: 24px;
            color: #bfbfbb;

            border-radius: 12px;
            border: 2px solid #DBDBDB;
            padding: 20px;
            width: 100%;
            resize: none;
            height: 176px;
        }

        /*按钮*/
        .btn-wrap {
            justify-content: space-between;
            margin-top: 24px;

            .btn1 {
                width: 264px;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #318544;
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 80px;
                text-align: center;
                box-sizing: border-box;
            }

            .btn2 {
                width: 352px;
                height: 80px;
                background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                border-radius: 12px;
                font-size: 28px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 80px;
                text-align: center;
            }
        }
        .btn-wrap1 {
            position: fixed;
            left: 33px;
            right: 33px;
            bottom: 0;
            margin-top: 24px;
            display: flex;
            align-items: center;
            flex-direction: column;
            background-color: #fff;
            .btn-wrap1-item{
                width: 95%;
                display: flex;
                justify-content:space-between;
                .btn1 {
                    width: 314px;
                    height: 80px;
                    border-radius: 12px;
                    border: 2px solid #899e8e;
                    font-size: 28px;
                    font-weight: 400;
                    color: #318544;
                    line-height: 80px;
                    text-align: center;
                    box-sizing: border-box;
                    background-color: #fff;
                }
                .confirmApply {
                    color: #FFFFFF;
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                }
            }
                .btn2 {
                    margin-top: 20px;
                    width: 95%;
                    margin-bottom: 54px;
                    height: 80px;
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    border-radius: 12px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 80px;
                    text-align: center;
                }
        }
    }

    /*预约弹窗样式*/
    .pop-wrap {
        min-height: 616px;
        background: #FFFFFF;
        border-radius: 16px;
        // overflow: hidden;

        .pop-title {
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
            line-height: 44px;
            text-align: center;
            margin-top: 40px;
        }

        .texttare-class {
            margin-top: 20px;
            padding: 0 40px;
            .text-style {
                padding: 20px;
                box-sizing: border-box;
                height: 220px;
                width: 100%;
                border-radius: 16px;
                background: #f7f7f7;
            }
        }

        .pop-content {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #318544;
            line-height: 40px;
            text-align: center;
            margin-top: 60px;
        }


          .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin: 24px 0;

            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
    }
    .cancelPopups {
        min-height:220px;
        margin-top: 84px;
        .pop-title {
            margin-top: 20px;
        }
    }

    /*海报弹窗*/
    .poster-pop-wrap {
        // .poster  {
        //     width: 624px;
        //     height: 1208px;
        //     // background-color: red;
        //     box-sizing: border-box;
        //     background-image: url('~@/assets/images/user/talk/poster-bg.png');
        //     background-size: cover;
        //     .logo {

        //     }
        // }
         .container{
            border-radius: 10px;
            width: 624px;
            height: 1208px;
            background-image: url('~@/assets/images/user/talk/invitationbg.png');
            background-size: cover;
            position: relative;
            padding-top:167px ;
            z-index:10;
            .poster {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height:1208px;
                opacity: 0;
                z-index: 13;
            }
            .logo{
                width: 236px;
                height: 28px;
                position: absolute;
                left: 62px;
                top: 86px;
            }
            .left {
                z-index: 999;
                width: 122px;
                height: 173px;
                position: absolute;
                top: 480px;
                left: 1px;
            }
            .center {
                width: 512px;
                height: 512px;
                margin: 0 auto ;
                background-image: url('~@/assets/images/user/talk/center.png');
                background-size: cover;
                position: relative;
                .title{
                    font-size: 38px;
                    font-weight: 500;
                    color: #986F34;
                    padding-top: 64px;
                    text-align: center;
                }
                .content {
                    padding: 21px 54px 0 92px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 35px;
                    p {
                        margin-bottom: 5px;
                        &:last-of-type {
                            margin-bottom: 0;
                        }
                        span {
                            white-space: nowrap;
                            text-align: center;
                            display: inline-block;
                            min-width: 107px;
                            border-bottom: solid 1px #000000;
                        }
                    }
                }
                .accept {
                    width: 295px;
                    height: 76px;
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%);
                    bottom: 51px;
                    .acceptimg{
                        width: 295px;
                        height: 74px;
                    }
                }
            }
            .address {
                display: flex;
                padding: 43px 61px 0 71px;
                .addr {
                    flex: 1;
                    p{
                        margin-bottom: 10px;
                    }
                    .address-title {
                        display: inline-block;
                        text-align: center;
                        border-left: #E5CEA4 1px solid ;
                        padding-left: 8px;
                        font-size: 24px;
                        font-family: SourceHanSansCN;
                        font-weight: 400;
                        color: #E5CEA4;
                    }
                    .address-name {
                        font-size: 24px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 20px;
                    }
                    .address-addr {
                        font-size: 20px;
                        font-weight: 300;
                        color: #FFFFFF;
                        line-height: 28px;
                    }
                }
                .navigation {
                    width: 71px;
                    height: 62px;
                    img {
                        width: 71px;
                        height: 62px;
                    }
                }
            }
            .time {
                margin-top: 31px;
                text-align: center;
                div{
                    display: inline-block;
                }
                div:first-child {
                    width: 119px;
                    font-size: 24px;
                    font-family: SourceHanSansCN;
                    font-weight: 400;
                    color: #E5CEA4;
                    border-left: solid 1px #E5CEA4;
                    border-right: solid 1px #E5CEA4;
                }
                div:last-child{
                    font-size: 24px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 18px;
                    margin-left: 13px;
                }
            }
            .userinfo {
                margin: 54px 95px 0 95px;
                border-top:#FFFFFF 1px solid ;
                border-bottom:#FFFFFF 1px solid ;
                padding: 12px 0;
                text-align: center;
                span:nth-child(1) {
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                span:nth-child(2) {
                    margin-left: 15px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                span:nth-child(3) {
                    margin-left: 20px;
                    font-size: 21px;
                    font-weight: 400;
                    color: #EBDBB6;
                }
                span:nth-child(4) {
                    font-size: 21px;
                    margin-left: 15px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
            .bottom{
                margin-top: 53px;
                text-align: center;
                line-height: 50px;
                
                .xieyi {
                    font-size: 18px;
                    font-family: SourceHanSansCN;
                    font-weight: 300;
                    color: #FFFFFF;
                    line-height: 50px;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                    .checkbox {
                        width: 17px;
                        height: 17px;
                        border-radius: 50%;
                        border: solid #FFFFFF 1px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        .check {
                            width: 10px;
                            border-radius: 50%;
                            height: 10px;
                            background-color: #FFFFFF;
                        }
                    }
                }
            }
            .right{
                width: 138px;
                height: 159px;
                position:absolute;
                top: 110px;
                z-index: 999;
                right: 1px;
            }
        }
       
        .pop-btn-wrap {
            .pop-btn {
                width: 296px;
                background: linear-gradient(136deg, #4EA062 0%, #338444 100%) !important;
                border: none;
                color: #fff!important;
            }
        }
        .pop-btn-wrap {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            margin-top: 24px;
            .pop-btn {
                width: 208px;
                height: 80px;
                font-size: 28px;
                font-weight: 400;
                line-height: 80px;
                text-align: center;
                border-radius: 12px;

                &:first-child {
                    border: 2px solid #318544;
                    color: #318544;
                }
                &:last-child {
                    background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                    color: #fff;
                }
            }
        }
        .pop-btn-wrap2 {
            margin-top: 24px;
            .item1{
                display: flex;
                justify-content: space-between;
                width: 100%;
                .pop-btn {
                    width: 278px;
                    height: 80px;
                    font-size: 28px;
                    font-weight: 400;
                    line-height: 80px;
                    text-align: center;
                    border-radius: 12px;
    
                    // &:first-child {
                        border: 2px solid #318544;
                        // color: #318544;
                    // }
                    // &:last-child {
                        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                        color: #fff;
                    // }
                }
            }
            .item2 {
                margin-top: 10px;
                position: relative;
                overflow: hidden;
                .pop-btn {
                    z-index:10;
                    width: 100%;
                    height: 80px;
                    font-size: 28px;
                    font-weight: 400;
                    line-height: 80px;
                    text-align: center;
                    border-radius: 12px;
    
                    // &:first-child {
                        border: 2px solid #318544;
                        // color: #318544;
                    // }
                    // &:last-child {
                        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
                        color: #fff;
                    // }
                }
                img {
                    z-index: 13;
                    opacity: 0;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom:0;
                }
            }
        }
    }
    // 选择用户下拉框
    .choosePeople {
        .chooseCell1 {
            display: flex;
            justify-content:space-between;
            align-items:center;
            span:nth-child(1){
                height: 44px;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #444444;
            }   
            span:nth-child(2) {
                width: 120px;
                height: 60px;
                background: #318544;
                border-radius: 8px;
                text-align: center;
                line-height: 60px;
                font-size: 28px;
                font-weight: 400;
                color: #FFFFFF;
            }
        }
        .choosePeopelBox {
            display: flex;
            flex-wrap: wrap;
            .item {
                margin-top: 28px;
                margin-right: 40px;
                width: 200px;
                height: 68px;
                background: rgba(49, 133, 68, 0.1);
                border-radius: 6px;
                display: flex;
                align-items: center;
                &:nth-child(3n){
                    margin-right: 0;
                } 
                span:nth-child(1) {
                    text-align: center;
                    flex: 1;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #318544;
                    line-height: 40px;
                }
                span:nth-child(2) {
                    width: 40px;
                    height: 40px;
                    margin-right: 20px;
                    img {
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }
    }
    /*分享下弹窗*/
    .share-pop-wrap {
        height: 100%;
        background: #fff;
        border-radius: 24px 24px 0px 0px;
        padding: 38px 32px 80px 36px;

        .share-pop-title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            div {
                font-size: 32px;
                font-weight: 400;
                color: #222222;
                line-height: 44px;
            }
            img {
                width: 32px;
                height: 32px;
            }
        }

        .share-list {
            margin-top: 46px;

            .share-item {
                width: 100%;
                background: #F6F9F6;
                border-radius: 12px;
                padding: 40px 30px 40px 32px;
                justify-content: space-between;
                margin-bottom: 24px;
                &:last-child {
                    margin: 0;
                }

                .share-item-left {
                    img {
                        width: 72px;
                        height: 72px;
                        margin-right: 24px;
                    }
                    div {
                        font-size: 28px;
                        font-weight: 400;
                        color: #222222;
                        line-height: 40px;
                    }
                }

                .share-item-right {
                    background: #318544;
                    border-radius: 30px;
                    padding: 14px 24px;

                    font-size: 24px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                }
            }
        }
    }

    /*通用样式*/
    .flc {
        display: flex;
        align-items: center;
    }

    .date-pop {
        width: 76%;
        top: 40.5%;
        border-radius: 16px;
    }

    .poster-pop {
        user-select: none;
        width: 83.2%;
        top: 50%;
        background: transparent !important;
    }

    .share-pop {
        border-radius: 24px 24px 0px 0px;
    }
    ::v-deep .van-overlay {
        z-index: 9!important;
    }
    ::v-deep .poster-pop {
        z-index: 10!important;
    }
</style>